import React, { useContext } from 'react';
import { NavLink, Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { 
  HomeIcon, 
  BookOpenIcon, 
  PhotoIcon, 
  UserCircleIcon, 
  UsersIcon, 
  ArrowRightOnRectangleIcon, 
  UserPlusIcon, 
  ShieldCheckIcon,
  ArrowDownTrayIcon // Import the download icon
} from '@heroicons/react/24/outline';

const Sidebar = ({ isOpen, onClose }) => {
  const { user, dispatch } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch({ type: 'LOGOUT' });
    onClose(); // Close sidebar on logout
    navigate('/'); // Redirect to home
  };

  const commonLinks = [
    { to: '/', icon: HomeIcon, text: 'होम' },
    { to: '/history', icon: BookOpenIcon, text: 'ग्राम इतिहास' },
    { to: '/villagers', icon: UsersIcon, text: 'सभी ग्रामवासी' },
    { to: '/ex-servicemen', icon: ShieldCheckIcon, text: 'भूतपूर्व सैनिक' },
    { to: '/downloads', icon: ArrowDownTrayIcon, text: 'डाउनलोड' }, // Added Downloads link
  ];

  const serviceLinks = [
      { to: '/form-filling', text: 'आवेदन करें' },
      { to: '/status-check', text: 'स्टेटस चेक करें' },
  ]

  const authLinks = user
    ? [{ to: '/admin', icon: UserCircleIcon, text: 'एडमिन डैशबोर्ड' }, { action: handleLogout, icon: ArrowRightOnRectangleIcon, text: 'लॉगआउट' }]
    : [
        { to: '/login', icon: ArrowRightOnRectangleIcon, text: 'प्रधान लॉगिन' },
      ];

  return (
    <>
      {/* Overlay for mobile */}
      <div
        className={`fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity duration-300 lg:hidden ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
        onClick={onClose}
      ></div>

      {/* Sidebar */}
      <aside
        className={`fixed top-0 left-0 w-64 bg-white h-full z-50 transform transition-transform duration-300 ease-in-out shadow-lg ${isOpen ? 'translate-x-0' : '-translate-x-full'} lg:translate-x-0 lg:flex lg:flex-col`}
      >
        <div className="flex-grow">
          <div className="px-4 py-5 border-b flex items-center justify-between">
            <Link to="/" className="flex items-center space-x-3" onClick={onClose}>
                <img src="/logo.png" alt="Logo" className="h-10 w-auto"/>
              <span className="text-lg font-bold text-blue-800">ग्राम पंचायत सिखेड़ा</span>
            </Link>
          </div>

          <nav className="py-4">
            <ul>
              {commonLinks.map((link, i) => (
                <li key={`common-${i}`}>
                    <NavLink
                      to={link.to}
                      onClick={onClose}
                      className={({ isActive }) =>
                        `flex items-center px-4 py-3 text-base font-medium transition-colors duration-200 ` +
                        (isActive ? 'bg-blue-50 text-blue-700' : 'text-slate-600 hover:bg-slate-50')
                      }
                    >
                      <link.icon className="h-6 w-6 mr-3" />
                      <span>{link.text}</span>
                    </NavLink>
                </li>
              ))}

              <li className="px-4 mt-4 mb-2">
                  <span className="text-xs font-semibold text-slate-500 uppercase">सेवाएं</span>
              </li>

              {serviceLinks.map((link, i) => (
                <li key={`service-${i}`}>
                     <NavLink
                      to={link.to}
                      onClick={onClose}
                      className={({ isActive }) =>
                        `flex items-center px-4 py-3 text-base font-medium transition-colors duration-200 ` +
                        (isActive ? 'bg-blue-50 text-blue-700' : 'text-slate-600 hover:bg-slate-50')
                      }
                    >
                      <span>{link.text}</span>
                    </NavLink>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <div className="border-t border-slate-200">
             <ul>
              {authLinks.map((link, i) => (
                <li key={`auth-${i}`}>
                  {link.to ? (
                    <NavLink
                      to={link.to}
                      onClick={onClose}
                      className={({ isActive }) =>
                        `flex items-center px-4 py-3 text-base font-medium transition-colors duration-200 ` +
                        (isActive ? 'bg-blue-50 text-blue-700' : 'text-slate-600 hover:bg-slate-50')
                      }
                    >
                      <link.icon className="h-6 w-6 mr-3" />
                      <span>{link.text}</span>
                    </NavLink>
                  ) : (
                    <button
                      onClick={link.action}
                      className="flex items-center w-full px-4 py-3 text-base font-medium text-slate-600 hover:bg-slate-50 transition-colors duration-200"
                    >
                      <link.icon className="h-6 w-6 mr-3" />
                      <span>{link.text}</span>
                    </button>
                  )}
                </li>
              ))}
            </ul>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
